var $01e38e0d24e067b8$exports = {};
$01e38e0d24e067b8$exports = {
    "help": `Ajuda`,
    "info": `Informa\xe7\xe3o`
};


export {$01e38e0d24e067b8$exports as default};
//# sourceMappingURL=pt-PT.module.js.map
